import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=9d25442a&"
import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=9d25442a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports